<template>
<v-container>
  <v-card
      class="mx-auto"
      tile>
    <v-data-table
        :headers="headers"
        :items="yatrikar_activities"
        :loading="loader"
        class="elevation-1"
        :rows-per-page-items="[10,25,50]"
        :pagination.sync="pagination"
        :total-items="total_items">
      <template v-slot:items="props">
        <td style="width: 20px;">
          <v-badge overlap left color="white">
            <v-avatar color="purple red--after" :size="40">
              <img :src="props.item.image_url != null ? storage_path()+'yatrikar_activities/'+props.item.image_url :
              '/images/default_user.png'"
              alt="Yatrikar">
            </v-avatar>
          </v-badge>
        </td>
        <td><router-link :to="{ name:'yatrikarMomentDetails', params: {id : props.item.id}}">
          {{ props.item.title}}
        </router-link></td>
        <td>{{ props.item.description }}</td>
        <td>
          <v-chip small v-if="(props.item.status) == '0'" label color="#F7F7B5"
                  text-color="#E0AC49">PENDING</v-chip>
          <v-chip small style="margin: 0px" v-if="(props.item.status) == '1'" label
                  color="#C8E6C9"
                  text-color="#1B5E20">APPROVED</v-chip>
          <v-chip small v-if="(props.item.status) == '2'" label
                  color="#FCCECB"
                  text-color="#F44336" >REJECTED</v-chip>
        </td>
        <td>
          <span v-if="props.item.approved_by">{{props.item.approved_by.first_name + " " + props.item.approved_by.last_name}}</span>
          <span v-if="props.item.rejected_by">{{props.item.rejected_by.first_name + " " + props.item.rejected_by
              .last_name}}</span>
          <span v-else>{{ " - " }}</span>
        </td>
      </template>
    </v-data-table>
  </v-card>

  <v-snackbar v-model="snackbar.display" :color="snackbar.color" :top="snackbar.top" :bottom="snackbar.bottom"
              :left="snackbar.left" :right="snackbar.right" :timeout="snackbar.timeout">
    {{ snackbar.message }}
    <v-btn
        text
        dark
        @click="snackbar.display = false"
    >
      <v-icon
          right
          color="white"
      >
        close
      </v-icon>
    </v-btn>
  </v-snackbar>

</v-container>
</template>

<script>
export default {
  name: "Index",
  data(){
    return{
      yatrikar_activities : [],
      snackbar: {
        message: '',
        display: false,
        color: 'black',
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000
      },
      headers: [
        { text: 'Image', value: '' },
        { text: 'Title', value: 'title' },
        { text: 'Description', value: 'description' },
        { text: 'Status', value: 'status' },
        { text: 'Approved / Rejected By', value: 'approved_by' },
      ],
      pagination: {sortBy: "updated_at", descending: true, rowsPerPage: 10},
      total_items: 0,
      loader: false,
    }
  },
  methods:{
    getYatrikarSharingMoments(){
      this.loader = true;
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/get-all-sharing-moments`, {
            params: this.pagination,
            headers: this.$headers,
          })
          .then((response) => {
            if(response.data.status == 1){
              this.loader = false;
              this.yatrikar_activities = response.data.data.data;
              this.total_items = response.data.data.total;
            }else if(response.data.status == 0){
              this.loader = false;
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;
            }
          })
          .catch((error) => {
            console.log(error);
            this.loader = false;
            this.snackbar.message = "Something went wrong";
            this.snackbar.display = true;
          })
    }
  },
  mounted() {
    this.getYatrikarSharingMoments();
    if (this.$route.params.message) {
      this.snackbar.display = true;
      this.snackbar.message = this.$route.params.message;
    }
  }
}
</script>

<style scoped>

</style>
